import { render, staticRenderFns } from "./MultiLanguageDetailDialog.vue?vue&type=template&id=1d6c8fd6&scoped=true&"
import script from "./MultiLanguageDetailDialog.vue?vue&type=script&lang=js&"
export * from "./MultiLanguageDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiLanguageDetailDialog.vue?vue&type=style&index=0&id=1d6c8fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c8fd6",
  null
  
)

export default component.exports